export const MINI_GAME_CHARTS_TIMELINE_DATES_GAP_BEFORE_HIDE = 4;

export const MINI_GAME_CHARTS_ORDER_CANVAS_HEIGHT = 180;

export const MINI_GAME_CHARTS_ORDER_TIMELINE_HEIGHT = 20;

export const MINI_GAME_CHARTS_ORDER_CHART_HEIGHT =
  MINI_GAME_CHARTS_ORDER_CANVAS_HEIGHT - MINI_GAME_CHARTS_ORDER_TIMELINE_HEIGHT;

export const MINI_GAME_CHARTS_COIN_CANVAS_HEIGHT = 180;

export const MINI_GAME_CHARTS_COIN_TIMELINE_HEIGHT = 20;

export const MINI_GAME_CHARTS_COIN_CHART_HEIGHT =
  MINI_GAME_CHARTS_COIN_CANVAS_HEIGHT - MINI_GAME_CHARTS_COIN_TIMELINE_HEIGHT;

export const MINI_GAME_CHARTS_LOADING_SCREEN_HEADER = "Loading Chart";

export const MINI_GAME_CHARTS_LOADING_SCREEN_DESCRIPTION =
  "We are loading, please wait.";
